import { motion } from "framer-motion";
import { Plus, MessageCircle } from "lucide-react";
import { useOrder } from "@/context/OrderContext";
import { waLink } from "@/lib/site";
import { useLang } from "@/context/LangContext";

export const ProductCard = ({ p, code, index = 0 }) => {
  const { add } = useOrder();
  const { t } = useLang();
  return (
    <motion.article
      layout
      data-testid={`product-card-${p.id}`}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: Math.min(index, 12) * 0.03 }}
      className="group flex flex-col"
    >
      <div className={`relative aspect-[4/5] overflow-hidden arch ${p.contain ? "bg-white" : "bg-[var(--mint)]"} ring-1 ring-leaf/10`}>
        <div className="absolute inset-x-[12%] bottom-[8%] top-[22%] rounded-full bg-white/70 blur-2xl transition-transform duration-700 group-hover:scale-110" />
        <img src={p.img} alt={p.name} loading="lazy" className={`relative h-full w-full ${p.contain ? "object-contain p-4 pt-10" : "object-cover"} transition-transform duration-700 ease-out group-hover:scale-[1.06]`} />
        {code && <span className="absolute left-3 top-[42%] rounded-full bg-white/90 px-2 py-0.5 font-display text-[11px] font-bold text-[var(--leaf-deep)]">{code}</span>}
        <div className="absolute inset-x-3 bottom-3 flex gap-2 opacity-100 transition-all duration-300 lg:translate-y-3 lg:opacity-0 lg:group-hover:translate-y-0 lg:group-hover:opacity-100">
          <button data-testid={`btn-add-order-${p.id}`} onClick={() => add(p)} className="flex-1 inline-flex items-center justify-center gap-1 rounded-full bg-[var(--leaf)] px-3 py-2 font-display text-xs font-bold text-white hover:bg-[var(--leaf-deep)]">
            <Plus className="h-3.5 w-3.5" /> {t("Pesanan", "Order")}
          </button>
          <a data-testid={`btn-wa-order-${p.id}`} href={waLink(t(`Halo Minaqu Indonesia, saya ingin memesan ${p.name}${p.price ? ` (${p.price})` : ""}.`, `Hello Minaqu Indonesia, I would like to order ${p.name}${p.price ? ` (${p.price})` : ""}.`))} target="_blank" rel="noreferrer"
            className="grid h-8 w-8 place-items-center rounded-full bg-white text-[var(--leaf)] hover:bg-[var(--mint)]" aria-label="Pesan via WhatsApp">
            <MessageCircle className="h-4 w-4" />
          </a>
        </div>
      </div>
      <div className="mt-3 px-1 text-center">
        <h3 className="font-display text-[13px] sm:text-sm font-bold leading-snug text-[var(--leaf-deep)]">{p.name}</h3>
        <p data-testid={`product-price-${p.id}`} className="mt-0.5 font-display text-sm font-extrabold text-[var(--ink)]">{p.price || t("Tanya harga", "Ask for price")}</p>
      </div>
    </motion.article>
  );
};
